module.exports = __webpack_public_path__ + "media/newMessage.fce0c803.mp3";